'use client'
import * as React from 'react'
import { Icon, type IconProps } from '../Icon'
const ThreeLinesHorizontal1Icon = React.forwardRef(
  (props: IconProps, ref: React.Ref<SVGSVGElement>) => {
    return (
      <Icon
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
      >
        <path d="M3 5.84C3 5.61722 3.07902 5.40356 3.21967 5.24603C3.36032 5.0885 3.55109 5 3.75 5H20.25C20.4489 5 20.6397 5.0885 20.7803 5.24603C20.921 5.40356 21 5.61722 21 5.84C21 6.06278 20.921 6.27644 20.7803 6.43397C20.6397 6.5915 20.4489 6.68 20.25 6.68H3.75C3.55109 6.68 3.36032 6.5915 3.21967 6.43397C3.07902 6.27644 3 6.06278 3 5.84Z" />
        <path d="M3 12C3 11.7772 3.07902 11.5636 3.21967 11.406C3.36032 11.2485 3.55109 11.16 3.75 11.16H20.25C20.4489 11.16 20.6397 11.2485 20.7803 11.406C20.921 11.5636 21 11.7772 21 12C21 12.2228 20.921 12.4364 20.7803 12.594C20.6397 12.7515 20.4489 12.84 20.25 12.84H3.75C3.55109 12.84 3.36032 12.7515 3.21967 12.594C3.07902 12.4364 3 12.2228 3 12Z" />
        <path d="M3 18.16C3 17.9372 3.07902 17.7236 3.21967 17.566C3.36032 17.4085 3.55109 17.32 3.75 17.32H20.25C20.4489 17.32 20.6397 17.4085 20.7803 17.566C20.921 17.7236 21 17.9372 21 18.16C21 18.3828 20.921 18.5964 20.7803 18.754C20.6397 18.9115 20.4489 19 20.25 19H3.75C3.55109 19 3.36032 18.9115 3.21967 18.754C3.07902 18.5964 3 18.3828 3 18.16Z" />
      </Icon>
    )
  },
)
export { ThreeLinesHorizontal1Icon }
